// generated file, if you want to edit this file manually change the word "generated" to "manual"
import MaterialAppBar from "@material-ui/core/AppBar";
import clsx from "clsx";
import React from "react";
import { excludeKeys, makeThemedStyles } from "./../utils";

const HEADER_FONT =
  '"Dubai", "Segoe UI", "Helvetica Neue", Arial, sans-serif';

const useStylesForAppBar = makeThemedStyles("AppBar", (theme) => ({
  AppBar: {
    background: "#ffffff !important",
    backgroundColor: "#ffffff !important",
    backgroundImage: "none !important",
    color: "#111111 !important",
    boxShadow: "none !important",
    borderBottom: "1px solid rgba(15, 23, 42, 0.08)",
    fontFamily: HEADER_FONT,
    // Beat MuiAppBar-colorPrimary (theme primary blue).
    "&.MuiAppBar-colorPrimary, &.MuiAppBar-colorSecondary, &.MuiAppBar-colorDefault":
      {
        background: "#ffffff !important",
        backgroundColor: "#ffffff !important",
        color: "#111111 !important",
      },
    "& .MuiTypography-root, & .MuiButton-label, & .MuiIconButton-label, & p, & span":
      {
        fontFamily: HEADER_FONT,
      },
    "& .MuiIconButton-root": {
      color: "#111111",
    },
    "& .MuiButton-root": {
      color: "#111111",
      fontFamily: HEADER_FONT,
      fontWeight: 600,
    },
  },
}));
type PropType = React.ComponentProps<typeof MaterialAppBar>;
export const AppBar: React.FunctionComponent<PropType> = (props: PropType) => {
  const styles = useStylesForAppBar();
  const enabledClasses = excludeKeys(styles, ["AppBar", "Icons", "UserMenu"]);
  /* eslint-disable */
  return (
    <MaterialAppBar
      {...props}
      color="default"
      elevation={0}
      classes={{
        root: styles.AppBar,
        ...enabledClasses,
      }}
      style={{
        ...(props?.style || {}),
        zIndex: 99999,
        backgroundColor: "#ffffff",
        backgroundImage: "none",
        color: "#111111",
        fontFamily: HEADER_FONT,
      }}
      className={clsx(styles.AppBar, props.className)}
    >
      {props?.children}
    </MaterialAppBar>
  );
};
export default AppBar;
